import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import StateServices from '../../services/StateServices';

function AddState() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({ 
    name: '' 

  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
      // Ensure the first letter is capitalized
      const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
    setFormValues({
      ...formValues,
      [name]: capitalizedValue,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {

      const res = await StateServices.createState({"name": formValues.name});
      // console.log(res);
      if (res.status === true) {
        alert('State added successfully');
        navigate('/state');
        setFormValues({ name: '' });
      } else {
        alert('Something went wrong');
      }
    } catch (error) {
      console.error('Failed to add state', error);
      alert('Failed to add state');
    }
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>State Add</h2>
        <div className="container-box-top-header-right">
          <Link className="list-banner-btn" to="/state">State List</Link>
        </div>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="input-field">
                <label>State Name*</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formValues.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <button className="submit-green-btn" type="submit">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddState;
